import { render, staticRenderFns } from "./classRecord.vue?vue&type=template&id=7b3a5275"
import script from "./classRecord.vue?vue&type=script&lang=js"
export * from "./classRecord.vue?vue&type=script&lang=js"
import style0 from "./classRecord.vue?vue&type=style&index=0&id=7b3a5275&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports